import { useCallback } from "react";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import { LojaPageContainer } from "../../common";
import ContasReceberSection from "../dashboard/components/ContasReceberSection";
import BaixaTituloDialog from "../dashboard/components/BaixaTituloDialog";
import CancelamentoTituloDialog from "../dashboard/components/CancelamentoTituloDialog";
import { useContasReceber } from "../dashboard/hooks/useContasReceber";
import { useContasFinanceirasFinanceiro } from "../dashboard/hooks/useContasFinanceirasFinanceiro";
import { useBaixaTitulo } from "../dashboard/hooks/useBaixaTitulo";
import { useCancelamentoTitulo } from "../dashboard/hooks/useCancelamentoTitulo";

/**
 * Contas a receber — títulos com baixa manual e cancelamento quando permitido.
 */
export default function LojaFinanceiroContasReceberPage() {
  const contasReceber = useContasReceber();
  const contasFinanceirasFinanceiro = useContasFinanceirasFinanceiro();

  const handleTitulosFinanceiroMutacaoSuccess = useCallback(() => {
    contasReceber.refetch();
  }, [contasReceber]);

  const baixaTitulo = useBaixaTitulo({
    onSuccess: handleTitulosFinanceiroMutacaoSuccess,
  });

  const cancelamentoTitulo = useCancelamentoTitulo({
    onSuccess: handleTitulosFinanceiroMutacaoSuccess,
  });

  return (
    <LojaPageContainer
      title="Contas a receber"
      subtitle="Recebíveis pendentes, vencidos e quitados; baixa e cancelamento quando aplicável."
    >
      <Stack spacing={3}>
        {baixaTitulo.feedback ? (
          <Alert
            severity={baixaTitulo.feedback.severity}
            onClose={baixaTitulo.clearFeedback}
            sx={{ borderRadius: 2 }}
          >
            {baixaTitulo.feedback.message}
          </Alert>
        ) : null}

        {cancelamentoTitulo.feedback ? (
          <Alert
            severity={cancelamentoTitulo.feedback.severity}
            onClose={cancelamentoTitulo.clearFeedback}
            sx={{ borderRadius: 2 }}
          >
            {cancelamentoTitulo.feedback.message}
          </Alert>
        ) : null}

        <ContasReceberSection
          embedded
          contasReceber={contasReceber}
          onBaixarTitulo={
            baixaTitulo.podeBaixaManual
              ? baixaTitulo.abrirBaixaReceber
              : undefined
          }
          onCancelarTitulo={
            cancelamentoTitulo.podeCancelarTitulo
              ? cancelamentoTitulo.abrirCancelamentoReceber
              : undefined
          }
        />

        <BaixaTituloDialog
          dialog={baixaTitulo.dialog}
          form={baixaTitulo.form}
          setForm={baixaTitulo.setForm}
          contasFinanceiras={contasFinanceirasFinanceiro.data}
          contasLoading={contasFinanceirasFinanceiro.loading}
          contasError={contasFinanceirasFinanceiro.error}
          loading={baixaTitulo.loading}
          error={baixaTitulo.error}
          onClose={baixaTitulo.fecharDialog}
          onConfirm={baixaTitulo.confirmarBaixa}
        />

        <CancelamentoTituloDialog
          dialog={cancelamentoTitulo.dialog}
          form={cancelamentoTitulo.form}
          setForm={cancelamentoTitulo.setForm}
          loading={cancelamentoTitulo.loading}
          error={cancelamentoTitulo.error}
          onClose={cancelamentoTitulo.fecharDialog}
          onConfirm={cancelamentoTitulo.confirmarCancelamento}
        />
      </Stack>
    </LojaPageContainer>
  );
}
